import React from 'react'
import { AnimatedCheckListItemProps } from './AnimatedCheckListItem'
import { Box, BoxProps } from '@homebotapp/hb-react-component-catalog'

interface AnimatedCheckListProps extends BoxProps {
  children: React.ReactElement<AnimatedCheckListItemProps> | Array<React.ReactElement<AnimatedCheckListItemProps>>
}

export const AnimatedCheckList = ({ children, ...boxProps }: AnimatedCheckListProps) => {
  return (
    <Box {...boxProps}>
      <Box
        as='ul'
        display='inline-block'
        textAlign='left'
        sx={{
          'li:not(:last-child)': {
            marginBottom: 2
          }
        }}
      >
        {children}
      </Box>
    </Box>
  )
}
